import {Component, Input, OnInit} from '@angular/core';
import {SessionService} from '../../../common/services/session.service';
import {FloatingMenuService, IFloatingMenuData} from '../../../common/services/floating-menu.service';

@Component({
  selector: 'ngx-one-column-layout',
  standalone: false,
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout [ngClass]="shouldShowProductSyncingNavbar && isNavbarShown ? 'with-top-navbar' : 'no-top-navbar'">
      <nb-layout-header fixed>
        <ngx-header [isProductSyncingNavbar]="shouldShowProductSyncingNavbar"></ngx-header>
      </nb-layout-header>

      <nb-sidebar class="menu-sidebar" tag="menu-sidebar" responsive start
                  [class.with-navbar]="shouldShowProductSyncingNavbar && isNavbarShown"
                  (stateChange)="onSidebarToggle($event)">
        <ng-content select="nb-menu"></ng-content>
      </nb-sidebar>

      <nb-layout-column [class.with-navbar]="shouldShowProductSyncingNavbar && isNavbarShown">
        <ng-content select="router-outlet"></ng-content>
        <floating-actions *ngIf="shouldShowFloatingMenu"
                          [buttonLeftPosition]="floatMenuLeftPosition"
                          [actionsMenuState]="actionsMenuState">
        </floating-actions>
      </nb-layout-column>
    </nb-layout>
  `,
})
export class OneColumnLayoutComponent implements OnInit {
  @Input() shouldShowProductSyncingNavbar: boolean = false;

  isNavbarShown: boolean = false;
  sidebarExpanded: boolean = true;
  floatMenuLeftPosition: string = 'calc(50% + 125px)';
  shouldShowFloatingMenu: boolean = false;
  actionsMenuState: IFloatingMenuData;

  constructor(private sessionService: SessionService,
              private floatingMenuService: FloatingMenuService,
  ) {
    this.sessionService.isProductsSyncNavbarShown$.subscribe((isNavbarShown: boolean) => {
      this.isNavbarShown = isNavbarShown;
    });
  }

  ngOnInit(): void {
    this.initFloatingMenuStateSubscription();
  }

  onSidebarToggle(state: string) {
    this.sidebarExpanded = state === 'expanded';
    this.updateButtonPosition();
  }

  updateButtonPosition() {
    this.floatMenuLeftPosition = this.sidebarExpanded ? 'calc(50% + 125px)' : '50%';
  }

  private initFloatingMenuStateSubscription(): void {
    this.floatingMenuService.floatingMenuState$.subscribe((menuState: IFloatingMenuData) => {
      if (!menuState) { return; }

      this.shouldShowFloatingMenu = menuState.isShown;
      this.actionsMenuState = menuState;
    });
  }
}
